<button
  mat-raised-button
  class="m-3"
  routerLink="/evaluator/dashboard/scheduling/scan"
>
  Scan Application
</button>
<div class="col-lg-6">
  <mat-form-field appearance="outline" [style.width.%]="100">
    <mat-label>Search</mat-label>
    <input
      matInput
      appCharactersOnly
      appNoLeadingSpaces
      placeholder="Search"
      [formControl]="searchControl"
    />
  </mat-form-field>
</div>
<div class="d-flex flex-column">
  <mat-card
    *ngFor="let application of filteredApplications"
    style="width: 100%; margin-bottom: 1rem"
  >
    <mat-card-content style="padding: 1rem; height: auto">
      <div class="row">
        <div class="col-lg-1">
          <div class="d-flex justify-content-center">
            <img
              *ngIf="application.workingPermitType == '1'"
              src="/assets/food-handler.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
            />
            <img
              *ngIf="application.workingPermitType == '2'"
              src="/assets/non-food.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
              style="margin-top: 2rem"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-lg-12" style="font-size: 15px">
            <mat-label
              >{{ application.applicationTypeName?.split("Permit")[0] }} Permit
              -
              {{
                application.workingPermitTypeName === "FoodHandler"
                  ? "Food"
                  : "Non Food"
              }}
              Handler
            </mat-label>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <mat-label class="label" style="color: #4caf50">{{
                application.apn
              }}</mat-label>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="col-lg-12 mb-2">
              <div class="user-container">
                <mat-icon>person</mat-icon>
                <mat-label style="margin-left: 5px">{{
                  application.applicantName
                }}</mat-label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <img src="/assets/occupation.png" alt="" srcset="" />
              <span style="margin-left: 5px">{{ application.occupation }}</span>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <img src="/assets/establishment.png" alt="" srcset="" />
              <mat-label style="margin-left: 5px"
                >{{ application.occupationEstablishment }},
                {{ application.occupationEstablishmentAddress }}</mat-label
              >
            </div>
          </div>
          <div class="col-lg-12 mb-2"></div>
        </div>
        <div class="col-lg-5">
          <div class="col-lg-12">
            <div class="d-flex justify-content-end"></div>
            <div class="d-flex justify-content-end">
              <mat-label style="color: #c0c0c0"
                >Submitted:
                {{ application.createdDate | date : "longDate" }}</mat-label
              >
              <!-- <p>{{ application.applicationStatusName }}</p>     -->
            </div>
            <div class="d-flex justify-content-end">
              <mat-label class="label"
                >Status:
                <span
                  *ngIf="
                    application.applicationStatusName == 'ParallelEvaluation'
                  "
                >
                  For Parallel Evaluation by BCPO and HSO</span
                >
                <!-- Incomplete -->
                <span *ngIf="application.applicationStatusName == 'Incomplete'">
                  Incomplete</span
                >
                <!-- Doctors Assesment -->
                <span
                  *ngIf="
                    application.applicationStatusName == 'ForDoctorsEvaluation'
                  "
                >
                  For Doctor's Assessment</span
                >
                <!-- HSO Processing -->
                <span *ngIf="application.applicationStatusName == 'HSOPending'">
                  Under Evaluation by Sanitation Division</span
                >
                <!-- X-Ray HSO - Processing -->
                <span
                  *ngIf="
                    application.applicationStatusName == 'XRayForHSOProcessing'
                  "
                >
                  X-Ray Examination - HSO Processing
                </span>
                <span
                  *ngIf="
                    application.applicationStatusName ==
                    'SpecimenForHSOProcessing'
                  "
                >
                  Stool Examination - HSO Processing
                </span>
                <span
                  *ngIf="
                    application.applicationStatusName == 'ForPaymentLabFee'
                  "
                >
                  Payment of Lab Fee
                </span>
                <span
                  *ngIf="
                    application.applicationStatusName == 'PendingRequirements'
                  "
                >
                  Pending Requirements
                </span>
                <span
                  *ngIf="
                    application.applicationStatusName == 'ForBCPOEvaluation'
                  "
                >
                  Under Evaluation by BCPO
                </span>
                <span
                  *ngIf="application.applicationStatusName == 'ForCompliance'"
                >
                  For Compliance
                </span>
              </mat-label>
            </div>
          </div>
          <div class="col-lg-12" style="margin-top: 2.5rem">
            <div class="d-flex justify-content-end">
              <div class="row g-0">
                <div class="col-lg-12">
                  <button
                    mat-raised-button
                    color="primary"
                    class="text-white"
                    (click)="handleSelect(application)"
                  >
                    <mat-icon>navigate_next</mat-icon>View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
